import * as Effects from 'redux-saga/effects'
import { put } from 'redux-saga/effects'
import { PaymentDictionaryActions } from '../../reducers/paymentDictionary/actionNames'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'
import { ActionNames } from '../../utils/FetchActionsName'
import { callFetch } from '../../actions/fetch'
import { fireToastSuccess } from '../../actions/toasts/fireToast'
import i18n from '../../i18n'
import {
  IPrepaymentMethod,
  loadPrepaymentMethod,
  updatePrepaymentMethod,
} from '../../models/PaymentDictionary'
import createAccountStripe from '../../models/PaymentDictionary/createAccountStripe'
import completeAccountStripe from '../../models/PaymentDictionary/completeAccountStripe'
import { change } from 'redux-form'

function* savePaymentMethod(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.UpdatePaymentMethod)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(
          actionNames.input,
          actionNames.output,
          updatePrepaymentMethod,
        ),
      ),
    ])

    const method = { ...action.values }

    if (method.p24_token === '' && method.transfer_p24) {
      yield Effects.put({
        type: PaymentDictionaryActions.PaymentMethodError,
      })
      return
    }

    const switches = [
      'transfer_stripe',
      'transfer_account',
      'transfer_dotpay',
      'transfer_paypal',
      'transfer_p24',
      'transfer_payu',
      'reservation_auto_delete_status',
      'payment_on_place',
    ]

    Object.entries(method).forEach(([key, value]) => {
      if (switches.includes(key)) {
        method[key] = value ? '1' : '0'
      }
    })

    const paymentMethod: IPrepaymentMethod = yield Effects.call(service, method)

    if ('error' in paymentMethod) {
      yield Effects.put({
        type: PaymentDictionaryActions.PaymentMethodError,
      })
    } else {
      yield Effects.put({
        paymentMethod: {
          ...paymentMethod,
          date: new Date(),
        },
        type: PaymentDictionaryActions.AcceptedPaymentMethod,
      })
      if(!method.hide_toast){
        yield put(fireToastSuccess(i18n.t('user_settings_updated')))
      }
    }
    yield put(change('paymentMethod', 'hide_toast', false))
  } catch (e) {
    yield put(change('paymentMethod', 'hide_toast', false))
    console.error(e)
  }
}

function* loadPayment() {
  try {
    const actionNames = fetchActionsName(ActionNames.FetchPaymentMethod)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, loadPrepaymentMethod),
      ),
    ])

    const paymentMethod: IPrepaymentMethod = yield Effects.call(service)

    yield Effects.put({
      paymentMethod,
      type: PaymentDictionaryActions.AcceptedPaymentMethod,
    })
  } catch (e) {
    console.error(e)
  }
}

function* createAccount() {
  try {
    const actionNames = fetchActionsName(ActionNames.CreateStripeAccount)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, createAccountStripe),
      ),
    ])

    const stripe = yield Effects.call(service)
    window.open(stripe.url, '_blank')
  } catch (e) {
    console.error(e)
  }
}
function* completeAccount() {
  try {
    const actionNames = fetchActionsName(ActionNames.CompleteStripeAccount)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, completeAccountStripe),
      ),
    ])

    const stripe = yield Effects.call(service)
    window.open(stripe.url, '_blank')
  } catch (e) {
    console.error(e)
  }
}

export default function*() {
  yield Effects.takeEvery(
    PaymentDictionaryActions.SavePaymentMethod,
    savePaymentMethod,
  )
  yield Effects.takeEvery(
    PaymentDictionaryActions.RequestPaymentMethod,
    loadPayment,
  )
  yield Effects.takeEvery(
    PaymentDictionaryActions.CreateStripeAccount,
    createAccount,
  )
  yield Effects.takeEvery(
    PaymentDictionaryActions.CompleteStripeAccount,
    completeAccount,
  )
}
